import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { HttpAuth } from './http-auth';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  private readonly url = `${environment.apiUrl}/api`;
  constructor(private readonly httpAuth: HttpAuth) {}

  public getSpecificationPdf(number: string) {
    return this.httpAuth.getFile(
      `${this.url}/users/me/specifications/${number}`
    );
  }

  public getInvoicePdf(number: string) {
    return this.httpAuth.getFile(`${this.url}/users/me/invoices/${number}`);
  }
}
